var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damages-view view" }, [
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", { staticClass: "view-title" }, [
          _vm._v(_vm._s(_vm.$t("addDamages.title"))),
        ]),
        _c(
          "ul",
          { staticClass: "view-list has-two-cols" },
          [
            _c(
              "li",
              [
                _c("ma-button", {
                  staticClass: "buttonAddDamage",
                  attrs: {
                    "qa-add-damage-btn": "",
                    handleButtonClick: _vm.handleClickAddDamages,
                    iconName: "plus",
                    buttonTitle: _vm.$t("addDamages.buttonTitle"),
                    buttonClass: "buttonsList",
                    type: "button",
                  },
                }),
              ],
              1
            ),
            _vm._l(_vm.damagesList, function (damage) {
              return _c(
                "li",
                [
                  _c("maButton", {
                    attrs: {
                      type: "buttonImg",
                      imgSrc:
                        damage.images.length > 0
                          ? damage.images[0].imageContent
                          : null,
                      buttonTitle: _vm.getSubtitle(damage.selfcare_title),
                      buttonClass: "buttonsList damageButton",
                      buttonSubtitle: damage.selfcare_subtitle,
                      idButton: damage.damage_id,
                    },
                    on: {
                      "click:btnDelete": _vm.handleDeleteDamage,
                      "click:photo": _vm.handleClickDamageDetail,
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        !_vm.isContinueBtnDisabled
          ? _c("ma-confrim-damages-btn", {
              attrs: {
                handleButtonClick: _vm.handleConfirmDamages,
                title: _vm.$t("actions.confirmAndContinue"),
                btnType: "functionalBtn",
                shouldBeDisabled: _vm.isContinueBtnDisabled,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }